export default __webpack_public_path__ + "static/media/iconModalEmptyDoc.44e26c46.svg";